import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Field, Form, SubmitHandler } from 'redux-form';
import Fields from 'components/Fields';
import { Selections } from './models';
import { QuestionType } from 'store/modules/Quesionnare/types';

const useStyles = makeStyles({
  answer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'calc(100% - 64px)',
    maxWidth: '1000px',
    minHeight: '50px',
    transition: 'all 0.3s ease-in-out',
    marginTop: '12px',
    marginBottom: '12px',
    borderRadius: '25px',
    backgroundColor: 'lightblue',
    paddingRight: '4px'
  },
  questionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    transition: 'all 0.3s ease-in-out'
  },
  question: {
    width: 'calc(100% - 64px)',
    transition: 'all 0.3s ease-in-out',
    marginBottom: '64px'
  },
  buttonsContainer: {
    width: 'calc(100% - 60px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '16px',
    paddingBottom: '16px'
  },
  form: {
    width: '100%'
  },
  questionText: {
    fontWeight: 600,
    width: '100%'
  }
});

interface QuestionaireQuestionsProps {
  surveyData: QuestionType[];
  selectedIndex: number;
  selections: Selections;
  handleSubmit: SubmitHandler;
  select: Function;
  setSelectionDetails: Function;
  createResponses: Function;
  displayTextarea: Function;
}

const QuestionaireQuestions = ({
  surveyData,
  selectedIndex,
  selections,
  handleSubmit,
  select,
  setSelectionDetails,
  displayTextarea
}: QuestionaireQuestionsProps) => {
  const classes = useStyles();

  const isActive = (question: any, selection: any, answer: any) => {
    if (question.multiselect) {
      return selection && selection.responses.includes(answer.text);
    }
    return selection && selection.text === answer.text;
  };

  return (
    <div style={{ marginTop: '24px', height: 'max-content' }}>
      <Form onSubmit={handleSubmit} className={classes.form}>
        {/* Render only the current question based on selectedIndex */}
        <div className={classes.questionContainer}>
          <div key={selectedIndex} className={classes.question}>
            {/* Question Text */}
            {surveyData[selectedIndex] && (
              <>
                <Typography component="h2" className={classes.questionText}>
                  {selectedIndex + 1 + '. ' + surveyData[selectedIndex].text}
                </Typography>

                {surveyData[selectedIndex].image_url && (
                  <img
                    src={surveyData[selectedIndex].image_url}
                    style={{
                      width: '100%',
                      maxWidth: '600px',
                      marginLeft: 'calc(50% - 300px)',
                      marginTop: '1rem',
                      marginBottom: '1rem'
                    }}
                  />
                )}
              </>
            )}
            {/* Answer Options */}
            {(surveyData[selectedIndex]?.responses ?? []).map((answer, idx) => {
              const active = isActive(
                surveyData[selectedIndex],
                selections[`Q${selectedIndex + 1}`],
                answer
              );
              return (
                <label
                  key={`question${idx + 1}`}
                  className={classes.answer}
                  style={{
                    backgroundColor: active ? '#7fb847' : 'lightgray',
                    color: active ? 'white' : 'black'
                  }}
                >
                  <div style={{ visibility: 'hidden' }}>
                    <Field
                      name={`question_${selectedIndex + 1}`}
                      component="input"
                      type="radio"
                      value={JSON.stringify({
                        question_id: surveyData[selectedIndex].id,
                        response_id: answer.id
                      })}
                      onClick={() =>
                        select(
                          `Q${selectedIndex + 1}`,
                          answer.text,
                          selectedIndex,
                          answer.id,
                          surveyData[selectedIndex].multiselect
                        )
                      }
                    />
                  </div>
                  {answer.text}
                </label>
              );
            })}

            {/* Textarea for Additional Comments */}
            {selections[`Q${selectedIndex + 1}`] &&
              displayTextarea(
                surveyData[selectedIndex].id,
                selections[`Q${selectedIndex + 1}`].text
              ) && (
                <Field
                  style={{ width: 'calc(100% - 64px)' }}
                  label={
                    surveyData[selectedIndex].label || 'Additional comments'
                  }
                  name={`question_${selectedIndex + 1}_details`}
                  component={Fields.Text}
                  multiline
                  minRows={4}
                  InputProps={{
                    onBlur: (e: any) =>
                      setSelectionDetails(
                        `Q${selectedIndex + 1}`,
                        e.target.value
                      )
                  }}
                />
              )}
          </div>
        </div>
      </Form>
    </div>
  );
};

export default QuestionaireQuestions;
